import { Switch, Theme, withStyles, createStyles } from '@material-ui/core'
import theme from 'presentation/styles/theme'
import styled from 'styled-components'

type ContainerProps = {
  width?: string
  height?: string
  noPadding?: boolean
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 50px 80px 36px 80px;
  max-width: 802px;
`

export const Header = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    margin-right: -40px;
    cursor: pointer;
  }
`

type TitleAndSubtitleProps = {
  fontColor: keyof typeof theme.colors
  fontSize: keyof typeof theme.font.sizes
  fontWeight?: keyof typeof theme.font
}

export const Title = styled.div<TitleAndSubtitleProps>`
  width: 100%;
  font-size: ${({ fontSize }) => theme.font.sizes[fontSize]};
  font-weight: ${({ theme }) => theme.font.black};
  color: ${({ fontColor }) => theme.colors[fontColor]};
  padding: 5px 0px 5px;
`

export const Subtitle = styled.div<TitleAndSubtitleProps>`
  width: 100%;
  font-size: ${({ fontSize }) => theme.font.sizes[fontSize]};
  color: ${({ fontColor }) => theme.colors[fontColor]};
  font-weight: ${({ fontWeight }) =>
    fontWeight ? theme.font[fontWeight] : ''};
`

type WrapperContainerTypes = {
  sendNotification?: boolean
}

export const WrapperContainer = styled.div<WrapperContainerTypes>`
  display: flex;
  align-items: center;
  padding: 17px 0px 17px 35px;
  background-color: #f5f5f5;
  margin-top: 20px;
  border-top: 1px solid #c2c2c2;
  border-bottom: 1px solid #c2c2c2;

  .megaphone {
    path {
      stroke: ${({ sendNotification }) => (sendNotification ? '#5278f2' : '')};
    }
  }
  .bell {
    path {
      fill: ${({ sendNotification }) => (sendNotification ? '#5278f2' : '')};
    }
  }
`

export const UglySwitch = withStyles((muiTheme: Theme) =>
  createStyles({
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: 'flex'
    },
    switchBase: {
      padding: 2,
      color: '#fff',
      '&$checked': {
        transform: 'translateX(12px)',
        color: muiTheme.palette.common.white,
        '& + $track': {
          opacity: 1,
          backgroundColor: '#5278f2',
          borderColor: '#5278f2'
        }
      }
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: 'none'
    },
    track: {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: '#d4d8d9'
    },
    checked: {}
  })
)(Switch)
